import { useEffect } from "react";

const DEFAULT_TITLE = "Shonta Solutions LLC | $500 Landlord Partnership Program";
const DEFAULT_DESC =
  "Shonta Solutions pays qualifying landlords a $500 partnership incentive, manages short-term rental operations, and shares monthly profits 80/20. No lease required.";

export default function Seo({ title, description }) {
  useEffect(() => {
    document.title = title || DEFAULT_TITLE;

    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const desc = description || DEFAULT_DESC;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", title || DEFAULT_TITLE);
    setMeta("property", "og:description", desc);
  }, [title, description]);

  return null;
}
